import {RepositoryFactory} from "../../scripts/RepositoryFactory";
import Vue from 'vue';
import SeatRepository from "@/scripts/repositories/seatRepository";
import TargetingRepository from "@/scripts/repositories/targetingRepository";
import ReportingRepository from "@/scripts/repositories/reportingRepository";
import AdvertiserRepository from "@/scripts/repositories/advertiserRepository";

const GroupRepository = RepositoryFactory.get('groups');
const UserRepository = RepositoryFactory.get('users');
const DeviceRepository = RepositoryFactory.get('devices');
const FormatRepository = RepositoryFactory.get('formats');
const PlacementRepository = RepositoryFactory.get('placements');
const SalesofficeRepository = RepositoryFactory.get('salesoffices');
const BrandingRepository = RepositoryFactory.get('brandings');
const DealTypeRepository = RepositoryFactory.get('dealTypes');
const state = {
    groups: null,
    users: null,
    devices: null,
    formats: null,
    placements: null,
    salesoffices: null,
    brandings: null,
    dealTypes: null,
    seats: null,
    targetings: null,
    reportings: null,
    advertisers: null,
    fetching: {
        groups: null,
        users: false,
        devices: false,
        formats: false,
        placements: false,
        salesoffices: false,
        brandings: false,
        dealTypes: false,
        seats: false,
        targetings: false,
        reportings: false,
        advertisers: false,
    },
    actionLoading: false,
    actionFailed: false,
    changesMade: false
};
const getters = {
    distinctDSPs() {
        let ret = state.seats ? [...new Set(state.seats.map(item => item.dsp))] : [];
        if (ret.length !== 0) {
            ret = ret.map((x) => {
                return {name: x}
            });
        }
        return ret;
    }
}

// actions
const actions = {
    // G R O U P
    async fetchGroups({state, commit}) {
        await fetchItems(
            state, commit,
            'groups',
            'setGroups',
            GroupRepository
        );
    },
    async createGroup({state, rootState}, json) {
        state.actionLoading = true;
        await GroupRepository.createGroup(json)
        .then(response => {
            if (response.data.status === "created") {
                state.changesMade = true;
                rootState.presets.groups.push(response.data.result);
                state.groups.push(response.data.result);
                state.actionFailed = false;
                Vue.noty.success('Gruppe wurde erfolgreich angelegt');
                state.actionLoading = false;
            }
        })
        .catch(error => {
            Vue.noty.error(parsedError(error));
            state.actionFailed = true;
            state.actionLoading = false;
        });
    },
    async updateGroup({state, rootState}, json) {
        try {
            state.actionLoading = true;
            const {data} = await GroupRepository.updateGroup(json.id, json);
            if (data.status === "updated") {
                state.changesMade = true;
                let index = state.groups.findIndex(x => x.id === data.result.id);
                Vue.set(state.groups, index, data.result);
                Vue.set(rootState.presets.groups, rootState.presets.groups.findIndex(x => x.id === data.result.id), data.result);
                state.actionLoading = false;
                state.actionFailed = false;
            }
            Vue.noty.success('Gruppe wurde erfolgreich geändert');
        } catch (e) {
            state.actionLoading = false;
            state.actionFailed = true;
            Vue.noty.error('Es ist ein Fehler aufgetreten');
        }
    },
    async deleteGroup({state, rootState}, id) {
        try {
            state.actionLoading = true;
            const {data} = await GroupRepository.deleteGroup(id);
            if (data.status === "deleted") {
                state.changesMade = true;
                let index = state.groups.findIndex(x => x.id === data.result.id);
                state.groups.splice(index, 1);
                rootState.presets.groups.splice(rootState.presets.groups.findIndex(x => x.id === data.result.id), 1);
                state.actionLoading = false;
                state.actionFailed = false;
            }
            Vue.noty.success('Gruppe wurde erfolgreich gelöscht');
        } catch (e) {
            state.actionLoading = false;
            state.actionFailed = true;
            Vue.noty.error('Es ist ein Fehler aufgetreten');
        }
    },


    // U S E R
    async fetchUsers({state, commit}) {
        await fetchItems(
            state, commit,
            'users',
            'setUsers',
            UserRepository
        );
    },
    async createUser({state, commit, rootState}, json) {
        state.actionLoading = true;
        await UserRepository.createUser(json)
        .then(response => {
            if (response.data.status === "created") {
                state.changesMade = true;
                state.users.push(response.data.result);
                state.actionFailed = false;
                if (rootState.users.userExists === false) {
                    // eslint-disable-next-line no-undef
                    let user = sso.getSsoUser();
                    if (typeof response.data.result.email !== "undefined" &&
                        (response.data.result.email === user.mail || response.data.result.email === user.mail_alias)) {
                        commit('users/userExists', {data: true}, {root: true});
                    }
                }
                fetchItems(state, commit, 'users', 'setUsers', UserRepository);
                state.actionLoading = false;
                Vue.noty.success('Benutzer wurde erfolgreich angelegt');
            }
        })
        .catch(error => {
            state.actionFailed = true;
            state.actionLoading = false;
            Vue.noty.error(parsedError(error));
        });
    },
    async updateUser({state, commit}, json) {
        await updateItem(
            state,
            'users',
            UserRepository,
            json,
            'Benutzer wurde erfolgreich geändert',
            commit,
            'setUsers'
        );
    },
    async deleteUser({state, commit}, id) {
        await deleteItem(
            state,
            'users',
            UserRepository,
            id,
            'Benutzer wurde erfolgreich gelöscht',
            commit,
            'setUsers'
        );
    },

    // D E V I C E
    async fetchDevices({state, commit}) {
        await fetchItems(
            state, commit,
            'devices',
            'setDevices',
            DeviceRepository
        );
    },
    async createDevice({state, commit}, json) {
        await createItem(
            state,
            'devices',
            DeviceRepository,
            json,
            'Device wurde erfolgreich angelegt',
            commit,
            'setDevices'
        );
    },
    async updateDevice({state, commit}, json) {
        await updateItem(
            state,
            'devices',
            DeviceRepository,
            json,
            'Device wurde erfolgreich geändert',
            commit,
            'setDevices'
        );
    },
    async deleteDevice({state, commit}, id) {
        await deleteItem(
            state,
            'devices',
            DeviceRepository,
            id,
            'Device wurde erfolgreich gelöscht',
            commit,
            'setDevices'
        );
    },

    // F O R M A T
    async fetchFormats({state, commit}) {
        await fetchItems(
            state, commit,
            'formats',
            'setFormats',
            FormatRepository
        );
    },
    async createFormat({state, commit}, json) {
        await createItem(
            state,
            'formats',
            FormatRepository,
            json,
            'Format wurde erfolgreich angelegt',
            commit,
            'setFormats'
        );
    },
    async updateFormat({state, commit}, json) {
        await updateItem(
            state,
            'formats',
            FormatRepository,
            json,
            'Format wurde erfolgreich geändert',
            commit,
            'setFormats'
        );
    },
    async deleteFormat({state, commit}, id) {
        await deleteItem(
            state,
            'formats',
            FormatRepository,
            id,
            'Format wurde erfolgreich gelöscht',
            commit,
            'setFormats'
        );
    },

    // P L A C E M E N T
    async fetchPlacements({state, commit}) {
        await fetchItems(
            state, commit,
            'placements',
            'setPlacements',
            PlacementRepository
        );
    },
    async createPlacement({state, commit}, json) {
        await createItem(
            state,
            'placements',
            PlacementRepository,
            json,
            'Placement wurde erfolgreich angelegt',
            commit,
            'setPlacements'
        );
    },
    async updatePlacement({state, commit}, json) {
        await updateItem(
            state,
            'placements',
            PlacementRepository,
            json,
            'Placement wurde erfolgreich geändert',
            commit,
            'setPlacements'
        );
    },
    async deletePlacement({state, commit}, id) {
        await deleteItem(
            state,
            'placements',
            PlacementRepository,
            id,
            'Placement wurde erfolgreich gelöscht',
            commit,
            'setPlacements'
        );
    },

    // S A L E S O F F I C E
    async fetchSalesoffices({state, commit}) {
        await fetchItems(
            state, commit,
            'salesoffices',
            'setSalesoffices',
            SalesofficeRepository
        );
    },
    async createSalesoffice({state, commit}, json) {
        await createItem(
            state,
            'salesoffices',
            SalesofficeRepository,
            json,
            'Verkaufsbüro wurde erfolgreich angelegt',
            commit,
            'setSalesoffices'
        );
    },
    async updateSalesoffice({state, commit}, json) {
        await updateItem(
            state,
            'salesoffices',
            SalesofficeRepository,
            json,
            'Verkaufsbüro wurde erfolgreich geändert',
            commit,
            'setSalesoffices'
        );
    },
    async deleteSalesoffice({state, commit}, id) {
        await deleteItem(
            state,
            'salesoffices',
            SalesofficeRepository,
            id,
            'Verkaufsbüro wurde erfolgreich gelöscht',
            commit,
            'setSalesoffices'
        );
    },

    // B R A N D I N G
    async fetchBrandings({state, commit}) {
        await fetchItems(
            state, commit,
            'brandings',
            'setBrandings',
            BrandingRepository
        );
    },
    async createBranding({state, commit}, json) {
        await createItem(
            state,
            'brandings',
            BrandingRepository,
            json,
            'Transparenz wurde erfolgreich angelegt',
            commit,
            'setBrandings'
        );
    },
    async updateBranding({state, commit}, json) {
        await updateItem(
            state,
            'brandings',
            BrandingRepository,
            json,
            'Transparenz wurde erfolgreich geändert',
            commit,
            'setBrandings'
        );
    },
    async deleteBranding({state, commit}, id) {
        await deleteItem(
            state,
            'brandings',
            BrandingRepository,
            id,
            'Transparenz wurde erfolgreich gelöscht',
            commit,
            'setBrandings'
        );
    },

    // D E A L   T Y P E
    async fetchDealTypes({state, commit}) {
        await fetchItems(
            state, commit,
            'dealTypes',
            'setDealTypes',
            DealTypeRepository
        );
    },
    async createDealType({state, commit}, json) {
        await createItem(
            state,
            'dealTypes',
            DealTypeRepository,
            json,
            'Deal Type wurde erfolgreich angelegt',
            commit,
            'setDealTypes'
        );
    },
    async updateDealType({state, commit}, json) {
        await updateItem(
            state,
            'dealTypes',
            DealTypeRepository,
            json,
            'Deal Type wurde erfolgreich geändert',
            commit,
            'setDealTypes'
        );
    },
    async deleteDealType({state, commit}, id) {
        await deleteItem(
            state,
            'dealTypes',
            DealTypeRepository,
            id,
            'Deal Type wurde erfolgreich gelöscht',
            commit,
            'setDealTypes'
        );
    },

    // S E A T
    async fetchSeats({state, commit}) {
        await fetchItems(
            state, commit,
            'seats',
            'setSeats',
            SeatRepository
        );
    },
    async createSeat({state, commit}, json) {
        await createItem(
            state,
            'seats',
            SeatRepository,
            json,
            'Seat wurde erfolgreich angelegt',
            commit,
            'setSeats'
        );
    },
    async updateSeat({state, commit}, json) {
        await updateItem(
            state,
            'seats',
            SeatRepository,
            json,
            'Seat wurde erfolgreich geändert',
            commit,
            'setSeats'
        );
    },
    async deleteSeat({state, commit}, id) {
        await deleteItem(
            state,
            'seats',
            SeatRepository,
            id,
            'Seat wurde erfolgreich gelöscht',
            commit,
            'setSeats'
        );
    },

    // T A R G E T I N G
    async fetchTargetings({state, commit}) {
        await fetchItems(
            state, commit,
            'targetings',
            'setTargetings',
            TargetingRepository
        );
    },
    async createTargeting({state, commit}, json) {
        await createItem(
            state,
            'targetings',
            TargetingRepository,
            json,
            'Targeting wurde erfolgreich angelegt',
            commit,
            'setTargetings'
        );
    },
    async updateTargeting({state, commit}, json) {
        await updateItem(
            state,
            'targetings',
            TargetingRepository,
            json,
            'Targeting wurde erfolgreich geändert',
            commit,
            'setTargetings'
        );
    },
    async deleteTargeting({state, commit}, id) {
        await deleteItem(
            state,
            'targetings',
            TargetingRepository,
            id,
            'Targeting wurde erfolgreich gelöscht',
            commit,
            'setTargetings'
        );
    },

    // R E P O R T I N G
    async fetchReportings({state, commit}) {
        await fetchItems(
            state, commit,
            'reportings',
            'setReportings',
            ReportingRepository
        );
    },
    async createReporting({state, commit}, json) {
        await createItem(
            state,
            'reportings',
            ReportingRepository,
            json,
            'Reporting wurde erfolgreich angelegt',
            commit,
            'setReportings'
        );
    },
    async updateReporting({state, commit}, json) {
        await updateItem(
            state,
            'reportings',
            ReportingRepository,
            json,
            'Reporting wurde erfolgreich geändert',
            commit,
            'setReportings'
        );
    },
    async deleteReporting({state, commit}, id) {
        await deleteItem(
            state,
            'reportings',
            ReportingRepository,
            id,
            'Reporting wurde erfolgreich gelöscht',
            commit,
            'setReportings'
        );
    },

    // A D V E R T I S E R
    async fetchAdvertisers({state, commit}) {
        await fetchItems(
            state, commit,
            'advertisers',
            'setAdvertisers',
            AdvertiserRepository
        );
    },
    async createAdvertiser({state, commit}, json) {
        await createItem(
            state,
            'advertisers',
            AdvertiserRepository,
            json,
            'Advertiser wurde erfolgreich angelegt',
            commit,
            'setAdvertisers'
        );
    },
    async updateAdvertiser({state, commit}, json) {
        await updateItem(
            state,
            'advertisers',
            AdvertiserRepository,
            json,
            'Advertiser wurde erfolgreich geändert',
            commit,
            'setAdvertisers'
        );
    },
    async deleteAdvertiser({state, commit}, id) {
        await deleteItem(
            state,
            'advertisers',
            AdvertiserRepository,
            id,
            'Advertiser wurde erfolgreich gelöscht',
            commit,
            'setAdvertisers'
        );
    },
};

// mutations
const mutations = {
    setGroups(state, data) {
        state.groups = data.data;
    },
    setUsers(state, data) {
        state.users = data.data;
    },
    setDevices(state, data) {
        state.devices = data.data;
    },
    setFormats(state, data) {
        state.formats = data.data;
    },
    setPlacements(state, data) {
        state.placements = data.data;
    },
    setSalesoffices(state, data) {
        state.salesoffices = data.data;
    },
    setBrandings(state, data) {
        state.brandings = data.data;
    },
    setDealTypes(state, data) {
        state.dealTypes = data.data;
    },
    setSeats(state, data) {
        state.seats = data.data;
    },
    setTargetings(state, data) {
        state.targetings = data.data;
    },
    setReportings(state, data) {
        state.reportings = data.data;
    },
    setAdvertisers(state, data) {
        state.advertisers = data.data;
    },
};

function parsedError(err) {
    let errorMsg = typeof err === 'string' ? err : JSON.parse(err.message);
    let ret = [];
    for (let error in errorMsg) {
        //translate
        errorMsg[error].forEach((msg, index) => {
            if (msg === "The name has already been taken.") {
                errorMsg[error][index] = "Dieser Eintrag existiert bereits.";
            } else if (msg === "The email has already been taken.") {
                errorMsg[error][index] = "Diese E-Mail wurde bereits vergeben.";
            }
        });
        ret.push(`${errorMsg[error]}`);
    }
    return ret.join(', \n');
}

async function fetchItems(state, commit, stateVariable, commitMethod, repository) {
    try {
        state.fetching[stateVariable] = true;
        const {data} = await repository.get();
        state.fetching[stateVariable] = false;
        state.actionFailed = false;
        commit(commitMethod, {data: data});
    } catch (e) {
        state.fetching[stateVariable] = false;
        state.actionFailed = true;
        Vue.noty.error('Es ist ein Fehler aufgetreten');
    }
}

async function createItem(state, stateVariable, repository, json, successMsg, commit, commitMethod) {
    try {
        state.actionLoading = true;
        const {data} = await repository.create(json);
        if (data.status === "created") {
            state.changesMade = true;
            state[stateVariable].push(data.result);
            state.actionLoading = false;
            state.actionFailed = false;
            fetchItems(state, commit, stateVariable, commitMethod, repository);
        }
        Vue.noty.success(successMsg);
    } catch (e) {
        state.actionLoading = false;
        state.actionFailed = true;
        Vue.noty.error('Es ist ein Fehler aufgetreten');
    }
}

async function updateItem(state, stateVariable, repository, json, successMsg, commit, commitMethod) {
    try {
        state.actionLoading = true;
        const {data} = await repository.update(json.id, json);
        if (data.status === "updated") {
            state.changesMade = true;
            state.actionLoading = false;
            state.actionFailed = false;
            fetchItems(state, commit, stateVariable, commitMethod, repository);
        }
        Vue.noty.success(successMsg);
    } catch (e) {
        state.actionLoading = false;
        state.actionFailed = true;
        Vue.noty.error('Es ist ein Fehler aufgetreten');
    }
}

async function deleteItem(state, stateVariable, repository, id, successMsg, commit, commitMethod) {
    try {
        state.actionLoading = true;
        const {data} = await repository.delete(id);
        if (data.status === "deleted") {
            state.changesMade = true;
            let index = state[stateVariable].findIndex(x => x.id === data.result.id);
            state[stateVariable].splice(index, 1);
            state.actionLoading = false;
            state.actionFailed = false;

            fetchItems(state, commit, stateVariable, commitMethod, repository);
        }
        Vue.noty.success(successMsg);
    } catch (e) {
        state.actionLoading = false;
        state.actionFailed = true;
        Vue.noty.error('Es ist ein Fehler aufgetreten');
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}